module.exports = __webpack_public_path__ + "static/media/icon-13.d6ea02a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/icon-13.png
// module id = 2569
// module chunks = 0